module.exports = __webpack_public_path__ + "img/doc_lang.663d3349.gif";